import React, {ReactElement, useEffect, useLayoutEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Navigate, Route, Routes} from 'react-router-dom';
import './external/animate.css';
import OfflineModal from './components/presentationView/parts/components/OfflineModal';
import QrCodeModal from './components/widget/qrCodeModal';
import RedirectModal from './components/widget/RedirectModal';
import {fetchLoggedInUserAction} from './store/actions/auth.actions';
import {updateSpinnerLoadingAction} from './store/actions/spinner.actions';
import {loggedInUserSelector} from './store/selectors/auth.selector';
import Callback from './ui/components/AAIEdu/Callback';
import Spinner from './ui/components/Spinner';
import PlayerPage from './ui/pages/playerPage/PlayerPage';
import PresentationPage from './ui/pages/PresentationPage';
import SlidePreviewCapturePage from './ui/pages/SlidePreviewCapturePage';
import PresWrapper from './ui/pages/PresWrapper';
import SlugWrapper from './ui/pages/SlugWrapper';
import LobbyPage from './ui/pages/room/lobby/LobbyPage';
import PlayPage from './ui/pages/room/PlayPage';
import RoomWrapper from './ui/pages/room/RoomWrapper';
import RoomSlugWrapper from './ui/pages/room/RoomSlugWrapper';
import {identifyPostHogUser} from './utils/posthog/posthog';

function App(): ReactElement {
    const dispatch = useDispatch();
    const loggedInUser = useSelector(loggedInUserSelector);

    useLayoutEffect(() => {
        dispatch(updateSpinnerLoadingAction(false));
    }, [dispatch]);

    useEffect(() => {
        if (!loggedInUser) dispatch(fetchLoggedInUserAction());
    }, [dispatch, loggedInUser]);

    useEffect(() => {
        identifyPostHogUser(loggedInUser);
    }, [loggedInUser]);

    return (
        <>
            <Spinner />
            <Routes>
                <Route path="/" element={<PlayerPage />} />

                <Route path="/room" element={<RoomWrapper />}>
                    <Route index path="lobby" element={<LobbyPage />} />
                    <Route path="play" element={<PlayPage />} />
                </Route>

                <Route path="/room/:slug" element={<RoomSlugWrapper />}>
                    <Route index path="lobby" element={<LobbyPage />} />
                    <Route path="play" element={<PlayPage />} />
                </Route>

                <Route path="/slide-preview" element={<SlidePreviewCapturePage />} />

                <Route element={<PresWrapper />}>
                    <Route path="/presentation" element={<PresentationPage />} />
                    <Route path="/sf" element={<PresentationPage />} />
                </Route>

                <Route path="/presentation/:slug" element={<SlugWrapper />} />

                <Route path="/authServiceCallback/:serviceName" element={<Callback />} />
                <Route path="/*" element={<Navigate replace to="/" />} />
            </Routes>

            <QrCodeModal />
            <RedirectModal />
            <OfflineModal />
        </>
    );
}

export default App;
